import React, { useState, useEffect } from 'react';
import Header from '../Common_Files/Header';
import Footer from '../Common_Files/Footer';
import config from '../Common_Files/Config';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
import CustomDateInput from '../CommonComp/CustomDateInput';
import Select from 'react-select';

const SupplierCredit = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [selectedPO, setSelectedPO] = useState(null);
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [purchaseItem, setPurchaseItem] = useState({});
    const [poDetails, setPoDetails] = useState({
        netAmount: '',
        vatAmount: '',
        totalAmount: ''
    });
    const [formData, setFormData] = useState({
        bill_date: '',
        bill_due_date: '',
        bill_no: '',
        job_ref: '',
        supplier_id: '',
        purchase_id: '',
        vat: '',
        vat_amount: ''
    });
    const accessToken = localStorage.getItem('accessToken');
    const user_id = localStorage.getItem('user_id');
    const navigateToPurchaseLedger = useNavigate();

    const roundMoney = (n) => Math.round((Number(n) || 0) * 100) / 100;

    const acceptAmount = (value) => {
        const cleaned = String(value).replace(/[^0-9.]/g, '');
        const parts = cleaned.split('.');
        if (parts.length <= 1) {
            return cleaned;
        }
        return `${parts[0]}.${parts.slice(1).join('')}`;
    };

    const applyAmountsFromNet = (netAmount, vatPercent) => {
        if (netAmount === '' || netAmount === null || netAmount === undefined) {
            return { netAmount: '', vatAmount: '', totalAmount: '' };
        }
        const net = parseFloat(netAmount);
        if (Number.isNaN(net)) {
            return { netAmount: '', vatAmount: '', totalAmount: '' };
        }
        const pct = parseFloat(vatPercent) || 0;
        const vat = roundMoney(net * (pct / 100));
        const total = roundMoney(net + vat);
        return {
            netAmount: net.toFixed(2),
            vatAmount: vat.toFixed(2),
            totalAmount: total.toFixed(2)
        };
    };

    useEffect(() => {
        if (!accessToken) {
            window.location.href = '/login';
            return;
        }
        // Fetch suppliers when the component mounts
        axios.get(`${config.api_url}/ws-purchase-not-billed-supplier`)
            .then(response => {
                if (response.data.supplier && Array.isArray(response.data.supplier)) {
                    setSuppliers(response.data.supplier);
                } else {
                    setSuppliers([]);
                }
            })
            .catch(() => {});
    }, []);


    const handleNetAmountChange = (e) => {
        setPoDetails((prev) => ({
            ...prev,
            netAmount: acceptAmount(e.target.value)
        }));
    };

    const handleNetAmountBlur = () => {
        setPoDetails((prev) => applyAmountsFromNet(prev.netAmount, formData.vat));
    };

    const handleVatAmountChange = (e) => {
        setPoDetails((prev) => ({
            ...prev,
            vatAmount: acceptAmount(e.target.value)
        }));
    };

    const handleVatAmountBlur = () => {
        const net = parseFloat(poDetails.netAmount) || 0;
        const vat = parseFloat(poDetails.vatAmount) || 0;
        setPoDetails({
            netAmount: net.toFixed(2),
            vatAmount: vat.toFixed(2),
            totalAmount: roundMoney(net + vat).toFixed(2)
        });
    };

    const handleVatPercentChange = (e) => {
        const vat = e.target.value;
        setFormData((prev) => ({ ...prev, vat }));
        setPoDetails((prev) => {
            if (prev.netAmount === '' || prev.netAmount === null || prev.netAmount === undefined) {
                return prev;
            }
            return applyAmountsFromNet(prev.netAmount, vat);
        });
    };


    const handleSupplierChange = (selectedOption) => {
        const supplierId = selectedOption ? selectedOption.value : '';
        setSelectedSupplier(selectedOption);
        setSelectedPO(null);
        setFormData((prev) => ({ ...prev, supplier_id: supplierId, purchase_id: '', job_ref: '' }));
        setPurchaseItem({});
        setPoDetails({
            netAmount: '',
            vatAmount: '',
            totalAmount: ''
        });

        if (supplierId) {
            axios.get(`${config.api_url}/ws-credit-supplier-po/${supplierId}`)
                .then(response => {
                    setPurchaseOrders(response.data);
                })
                .catch(error => console.error(error));
        } else {
            setPurchaseOrders([]);
        }
    };

    const handlePoChange = (selectedOption) => {
        const poId = selectedOption ? selectedOption.value : '';
        setSelectedPO(selectedOption);
        const jobFromSelect = selectedOption?.job_ref ?? selectedOption?.jobRef ?? '';
        setFormData((prev) => ({ ...prev, purchase_id: poId, job_ref: poId ? jobFromSelect : '' }));
        if (poId) {
            axios.get(`${config.api_url}/ws-get-po-details-for-credit/${poId}`)
                .then(response => {
                    const raw = response.data?.purchase;
                    const rows = Array.isArray(raw) ? raw : raw && typeof raw === 'object' ? [raw] : [];
                    const first = rows[0] || {};
                    setPurchaseItem(raw);
                    setPoDetails({
                        netAmount: (parseFloat(first.net_std_goods || 0.00) + parseFloat(first.net_zero_goods || 0.00)).toFixed(2),
                        vatAmount: parseFloat(first.net_vat_amount || 0.00).toFixed(2),
                        totalAmount: parseFloat(first.net_grand_total || 0.00).toFixed(2),
                    });
                    const poFromList = purchaseOrders.find((p) => String(p.id) === String(poId));
                    const jobRef = first.job_ref ?? first.jobRef ?? response.data?.job_ref ?? response.data?.jobRef ?? poFromList?.job_ref ?? poFromList?.jobRef ?? jobFromSelect ?? '';
                    setFormData((prev) => ({ ...prev, job_ref: jobRef }));
                })
                .catch(error => console.error(error));
        } else {
            setPurchaseItem({});
            setFormData((prev) => ({ ...prev, job_ref: '' }));
            setPoDetails({
                netAmount: '',
                vatAmount: '',
                totalAmount: ''
            });
        }
    };

    const handleSubmit = (e, action) => {
        e.preventDefault();
        const formElement = document.getElementById("new_sales_order");
        const submitFormData = new FormData(formElement);
        const amounts = applyAmountsFromNet(
            submitFormData.get('net_amount'),
            submitFormData.get('vat') || formData.vat
        );
        if (amounts.netAmount !== '') {
            submitFormData.set('net_amount', amounts.netAmount);
            submitFormData.set('vat_amount', amounts.vatAmount);
            submitFormData.set('total_amount', amounts.totalAmount);
            setPoDetails(amounts);
        }

        let purchase_id = $('#po').val();
        let supplier_id = $('#supplier').val();
        let bill_no = $('#bill_no').val();
        const jobRefValue = submitFormData.get('job_ref');

        let message = '';
        // if (!purchase_id) {
        //     message = 'Please select the Purchase Order.';
        // }

        if (!supplier_id) {
            message = 'Please select the Supplier.';
        }

        if (!bill_no) {
            message = 'Please enter the Bill Number.';
        }

        if (!String(jobRefValue || '').trim()) {
            message = 'Please enter the Job Reference.';
        }

        if (message !== '') {
            Swal.fire({
                title: "Error!",
                text: message,
                icon: "error",
                timer: 1500,
                showConfirmButton: false,
            })
            return;
        }

        submitFormData.append('type', 'Credit');
        submitFormData.append('user_id', user_id);

        axios.post(`${config.api_url}/submit-supplier-credit`, submitFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
            .then(response => {
                Swal.fire({
                    title: "Success",
                    text: "Supplier bill submitted successfully",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false,
                });

                if (action === 'close') {
                    navigateToPurchaseLedger('/PurchaseLedger');
                } else if (action === 'new') {
                    setFormData({
                        bill_date: '',
                        bill_due_date: '',
                        bill_no: '',
                        job_ref: '',
                        supplier_id: '',
                        purchase_id: '',
                        vat: '',
                        vat_amount: ''
                    });

                    setPurchaseItem([]);
                    setSelectedSupplier(null);
                    setSelectedPO(null);
                    setPurchaseOrders([]);
                    setPoDetails({
                        netAmount: '',
                        vatAmount: '',
                        totalAmount: ''
                    });
                }
            })
            .catch(error => {
                console.error('There was an error submitting the form:', error);
            });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const supplierOptions = suppliers.map((supplier) => ({
        value: supplier.id,
        label: supplier.name
    }));

    const purchaseOrderOptions = purchaseOrders.map((po) => ({
        value: po.id,
        label: po.reference_no,
        job_ref: po.job_ref ?? po.jobRef
    }));

    return (
        <div>
            <Header />
            <div className="breadcrumbs">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-lg-12 col-sm-12">
                            <a href="#"><i className="fa fa-home"></i></a> &gt;
                            <a href="/Dashboard">Dashboard</a> &gt;
                            <span className="last-crumb">Supplier Credit</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container">
                <form id='new_sales_order'>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 col-lg-12 col-sm-12">
                                <div className="show-order-area dashboard">
                                    <div style={{ marginBottom: '20px', float: 'left', width: '100%' }}>
                                        <div className="newsalesorderform">
                                            <div className="row mb-3 padd-l-13px">
                                                <div className="col-6 col-lg-6 col-sm-6">
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="supplier" className="col-form-label">Select Supplier <span className='red'>*</span> </label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="hidden" name='supplier_id' id="supplier" value={formData.supplier_id || ''} />
                                                            <Select
                                                                options={supplierOptions}
                                                                value={selectedSupplier}
                                                                onChange={handleSupplierChange}
                                                                isClearable
                                                                components={{ IndicatorSeparator: () => null }}
                                                                placeholder="Select Supplier"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="bill_date" className="col-form-label">Bill Date </label>
                                                        </div>
                                                        <div className="col-8 col-lg-3 col-sm-3">
                                                            <CustomDateInput
                                                                name="bill_date"
                                                                id="bill_date"
                                                                value={formData.bill_date}
                                                                onChange={handleChange}
                                                            />
                                                        </div>

                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="bill_due_date" className="col-form-label">Bill Due Date </label>
                                                        </div>
                                                        <div className="col-8 col-lg-3 col-sm-3">
                                                            <CustomDateInput
                                                                name="bill_due_date"
                                                                id="bill_due_date"
                                                                value={formData.bill_due_date}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="bill_no" className="col-form-label">Bill No <span className='red'>*</span> </label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" className="form-control" name='bill_no' id="bill_no" autoComplete='off' onChange={handleChange} value={formData.bill_no} />
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-6 col-lg-6 col-sm-6">
                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="po" className="col-form-label">Select P.O.</label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="hidden" id="po" name="purchase_id" value={formData.purchase_id || ''} />
                                                            <Select
                                                                options={purchaseOrderOptions}
                                                                value={selectedPO}
                                                                onChange={handlePoChange}
                                                                isClearable
                                                                components={{ IndicatorSeparator: () => null }}
                                                                placeholder="Select Purchase Order"
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="job_ref" className="col-form-label">Job Ref <span className='red'>*</span></label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <input type="text" name="job_ref" className="form-control" id="job_ref" autoComplete='off' value={formData.job_ref || ''} onChange={handleChange} required />
                                                        </div>
                                                    </div>

                                                    <div className="row mb-3">
                                                        <div className="col-4 col-lg-3 col-sm-3">
                                                            <label htmlFor="vat" className="col-form-label">VAT %</label>
                                                        </div>
                                                        <div className="col-8 col-lg-9 col-sm-9">
                                                            <select
                                                                name="vat"
                                                                className="form-select orgselect"
                                                                value={formData.vat ?? ''}
                                                                id="vat"
                                                                onChange={handleVatPercentChange}
                                                            >
                                                                <option value="">Select VAT</option>
                                                                <option value="20">20 %</option>
                                                                <option value="0">0 %</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="purchaseform">
                                                <div className="row">
                                                    <div className="col-12 col-lg-12 col-sm-12">
                                                        <div className="row mb-3">
                                                            <div className="col-6 col-lg-1 col-sm-1">
                                                                <label htmlFor="net_amount" className="col-form-label">Net Amount </label>
                                                            </div>
                                                            <div className="col-6 col-lg-3 col-sm-3">
                                                                <input type="text" className="form-control" name='net_amount' id="net_amount" onChange={handleNetAmountChange} onBlur={handleNetAmountBlur} value={poDetails.netAmount} autoComplete="off" />
                                                            </div>

                                                            <div className="col-6 col-lg-1 col-sm-1">
                                                                <label htmlFor="vat_amount" className="col-form-label">VAT </label>
                                                            </div>
                                                            <div className="col-6 col-lg-3 col-sm-3">
                                                                <input type="text" className="form-control" name='vat_amount' id="vat_amount" onChange={handleVatAmountChange} onBlur={handleVatAmountBlur} value={poDetails.vatAmount} autoComplete="off" />
                                                            </div>

                                                            <div className="col-6 col-lg-1 col-sm-1">
                                                                <label htmlFor="total_amount" className="col-form-label">Total </label>
                                                            </div>
                                                            <div className="col-6 col-lg-3 col-sm-3">
                                                                <input type="text" className="form-control" name='total_amount' id="total_amount" value={poDetails.totalAmount} readOnly />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <a href="#" className="common-closebtn">Cancel</a> &nbsp;
                                            <div className="btn-group bouble-btn" role="group" aria-label="Basic example">
                                                <button type="submit" className="saveclose" onClick={(e) => handleSubmit(e, 'close')}>Save & Close</button>
                                                <button type="submit" className="savenew" onClick={(e) => handleSubmit(e, 'new')}>Save & New</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <Footer />
        </div>
    );
};

export default SupplierCredit;
